import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { stylesCP } from "../../../src/styles/scheduleTelcelBillPayments";
import { getScheduleTelcelBillPaymentContract } from "../../store/actions";
import ModalCardLoader from "../molecules/ModalCardLoader";
import { SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS } from "../../constants";
import { executeTaggeo } from "../../store/actions";
import { validateUserAgent } from "../organisms/utils";

class ScheduleTelcelBillPaymentsContract extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { getScheduleTelcelBillPaymentContract, history, executeTaggeo } =
      this.props;
    const { maxAmount, minAmount, tagServiceId } =
      history.location.state;

    getScheduleTelcelBillPaymentContract(
      SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS.bank,
      maxAmount,
      minAmount,
      SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS.periodicity,
      SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS.product,
      SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS.providerService
    );
    setTimeout(() => {
      executeTaggeo({
        action: "View TyC",
        step: "Domiciliar pagos",
        service: tagServiceId,
      });
    }, 500);
  }

  getStyles() {
    return stylesCP;
  }

  render() {
    const styles = this.getStyles();
    const { scheduleTecelContract, isLoadigGetScheduleTelcelBillPayments } =
      this.props;
    if (validateUserAgent() !== "android") {
      styles.termsIframe.minHeight = "90%";
    }
    return (
      <>
        {scheduleTecelContract && scheduleTecelContract.html && (
          <div
            style={styles.termsIframe}
            dangerouslySetInnerHTML={{ __html: scheduleTecelContract.html }}
          >
          </div>
        )}

        <ModalCardLoader isOpen={isLoadigGetScheduleTelcelBillPayments} />
      </>
    );
  }
}

function mapStateToProps(state) {
  const { isLoadigGetScheduleTelcelBillPayments, scheduleTecelContract } =
    state.payments;
  return {
    isLoadigGetScheduleTelcelBillPayments,
    scheduleTecelContract,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getScheduleTelcelBillPaymentContract,
      executeTaggeo,
    },
    dispatch
  );
}

ScheduleTelcelBillPaymentsContract = connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleTelcelBillPaymentsContract);

export default ScheduleTelcelBillPaymentsContract;
